// extracted by mini-css-extract-plugin
export default {"subscriptionDetails":"PriceBreakdown_subscriptionDetails__YNOmR","spaceBetween":"PriceBreakdown_spaceBetween__7BB1Y"};